var KHweixin = {
    appid:"wxc2247485508262b2" //测试
}

// var KHweixin = {
//     appid:"wx3927466a26b32948" //正式
// }

export default KHweixin


// WEBPACK FOOTER //
// ./src/wx/weixinData.js